import Footer from "./components/footer/Footer";
import RouteIndex from "./routeIndex/RouteIndex";


function App() {
  return (
    <div className="App">
      {/* <Navbar/> */}
      <RouteIndex/>
      <Footer/>
    </div>
  );
}

export default App;
